import { useState } from 'react';
import Button from 'Components/Atoms/Button/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function ServiceOut(props) {
    const { onClearConnection, onClose, info } = props;
    const [processing, setProcessing] = useState(false);

    const { t } = useTranslation('providers');

    const handleReject = async () => {
        setProcessing(true);
        await onClearConnection();
        setProcessing(false);
        onClose();
    };

    return (
        <div className="text-center">
            <div className="flex justify-center mb-6">
                <img src="/img/icon-error.svg" alt="" />
            </div>

            <h4>{t('service-out-title')}</h4>
            <div className="text-gray-500">{t('service-out-description')}</div>

            {info.service_message && (
                <div className="mt-6">
                    <div className="text-xs text-left text-gray-500 mb-1">{t('service-out-provider-message')}</div>
                    <div className="alert alert-warning" role="alert">
                        {info.service_message}
                    </div>
                </div>
            )}

            <Button variant="primary" isBusy={processing} className="mt-6" onClick={handleReject}>
                {t('accept')}
            </Button>
        </div>
    );
}

ServiceOut.propTypes = {
    onClearConnection: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    info: PropTypes.object.isRequired,
};
